import React from 'react';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Typography} from 'components/Typography';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import Icon from 'components/Icon';

type TStickersProps = Pick<IProductSnippet, 'stickers'>;

export const Stickers = (props: TStickersProps) => {
    const {stickers} = props;

    if (0 === stickers.length) {
        return null;
    }

    return (
        <div className={style.root}>
            {stickers.map((item) => {
                if ('alcohol' === item.code) {
                    return (
                        <div key={item.code} className={style.alcohol}>
                            <Typography variants={{DT: 'label-14-m', TB: 'label-10-m-up', MB: 'label-10-m-up'}}>
                                {item.text}
                            </Typography>
                        </div>
                    );
                }
                if ('cultivationType' === item.code) {
                    return (
                        <Tooltip
                            key={item.code}
                            childrenClassName={style.tooltip}
                            overlay={
                                <Typography className={style.overlay} variant={'label-12-r'}>
                                    {item.text}
                                </Typography>
                            }
                            place={'bottom'}
                        >
                            <Icon className={style.cultivationType} icon={'organic'} />
                        </Tooltip>
                    );
                }
                return null;
            })}
        </div>
    );
};
